// src/components/Breadcrumbs.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const breadcrumbNameMap = {
    '': 'Home',
    'articles': 'Articles',
    'calculators': 'Calculators',
    'article': 'Article',
    'search': 'Search'
  };

  return (
    <nav className="text-sm text-slate-600 dark:text-slate-400 mb-6">
      <div className="container mx-auto px-4">
        <Link to="/" className="hover:text-orange-500 transition-colors">
          Home
        </Link>
        
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const name = breadcrumbNameMap[value] || value.replace(/-/g, ' ');

          return (
            <span key={to}>
              <span className="mx-2">/</span>
              {isLast ? (
                <span className="text-slate-800 dark:text-slate-200 font-medium">
                  {name}
                </span>
              ) : (
                <Link 
                  to={to} 
                  className="hover:text-orange-500 transition-colors"
                >
                  {name}
                </Link>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumbs;